'use client'

import { ThemeToggle } from './ThemeToggle'

/**
 * Global ThemeToggle wrapper for use in root layout
 * Fixed position in top-right corner, accessible on all pages
 */
export function GlobalThemeToggle() {
  return (
    <div className="fixed top-4 right-4 z-50 pointer-events-auto">
      <ThemeToggle />
    </div>
  )
}

